/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2024) Takeda. All Rights Reserved
 */

import { useLocation } from 'react-router-dom';

export function useParams() {
  const params = new URLSearchParams(useLocation().search);

  const getStringParam = (name: string) => {
    return params.get(name);
  };

  const getBooleanParam = (name: string) => {
    return params.get(name)?.toLowerCase() === 'true';
  };

  const hasKeys = () => {
    return Array.from(params.keys()).length > 0;
  };

  const getAllKeys = () => {
    return params.keys();
  };

  const setStringParam = (name: string, value: string) => {
    return params.set(name, value);
  };

  return {
    params,
    getStringParam,
    getBooleanParam,
    setStringParam,
    hasKeys,
    getAllKeys,
  };
}
